import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const InfoCardBase = (
  <path
    fill='currentColor'
    fillRule='evenodd'
    d='M4 2.667c-1.105 0-2 .895-2 2v6.666c0 1.105.895 2 2 2h8c1.105 0 2-.895 2-2V4.666c0-1.104-.895-2-2-2H4zm0 4c-.368 0-.667.298-.667.666 0 .368.299.667.667.667h2.667c.368 0 .666-.299.666-.667 0-.368-.298-.667-.666-.667H4zm-.667 2.666c0-.368.299-.667.667-.667h8c.368 0 .667.299.667.667 0 .368-.299.667-.667.667H4c-.368 0-.667-.299-.667-.667zM4 10.666c-.368 0-.667.299-.667.667 0 .368.299.667.667.667h8c.368 0 .667-.299.667-.667 0-.368-.299-.667-.667-.667H4z'
  />
)

export const InfoCard = createIcon({
  displayName: 'InfoCard',
  viewBox: '0 0 16 16',
  path: InfoCardBase,
})
